import { App } from '@capacitor/app';
import type { PluginListenerHandle } from '@capacitor/core';
import { isNative } from './native';

/** אירוע window שה-SignalRProvider מאזין לו כדי להתחבר מחדש מיד (חזרה מרקע) */
export const SOCKET_RECONNECT_NOW_EVENT = 'funner:socket-reconnect-now';

export type BackButtonHandler = () => boolean; // true = טופל, false = לצאת מהאפליקציה

/**
 * מחבר את אירועי המערכת של האפליקציה: חזרה מרקע (רענון סוקט) וכפתור Back של אנדרואיד.
 * מחזיר פונקציית ניקוי.
 */
export const attachAppLifecycle = (opts: { onBack: BackButtonHandler; onResume?: () => void; onUrlOpen?: (url: string) => void }) => {
  if (!isNative) return () => undefined;

  const handles: Promise<PluginListenerHandle>[] = [];

  handles.push(
    App.addListener('appStateChange', ({ isActive }) => {
      if (!isActive) return;
      window.dispatchEvent(new CustomEvent(SOCKET_RECONNECT_NOW_EVENT));
      opts.onResume?.();
    }),
  );

  handles.push(
    App.addListener('backButton', () => {
      const handled = opts.onBack();
      if (!handled) void App.exitApp();
    }),
  );

  if (opts.onUrlOpen) {
    const onUrlOpen = opts.onUrlOpen;
    handles.push(App.addListener('appUrlOpen', ({ url }) => onUrlOpen(url)));
  }

  return () => {
    handles.forEach((h) => h.then((handle) => handle.remove()).catch(() => undefined));
  };
};
